import { Color } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

export const Line = () => <Box h="1px" background={Color['neutral.lightest']} />;
